import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "@phosphor-icons/react";
import { IMAGES } from "@/data/content";
import { Reveal } from "@/components/Reveal";

const AUDIENCE = ["General Contractors", "HVAC Companies", "Property Managers", "Building Owners"];
const HIGHLIGHTS = ["Install-only support", "Subcontract capability", "Clear scope", "Documentation", "Reliable communication", "Jobsite professionalism", "Clean handoff"];

export const CommercialPartner = () => (
  <section data-testid="commercial-partner" className="relative overflow-hidden border-t border-white/10 py-24 md:py-32">
    <div className="absolute inset-0">
      <img src={IMAGES.rtu} alt="Rooftop unit" className="h-full w-full object-cover opacity-15" />
      <div className="absolute inset-0 bg-ink/80" />
      <div className="blueprint-grid absolute inset-0 opacity-30" />
    </div>
    <div className="relative mx-auto max-w-[1440px] px-6 md:px-12">
      <Reveal className="grid gap-10 lg:grid-cols-[1.3fr_1fr] lg:items-end">
        <div>
          <div className="mb-4 flex items-center gap-3">
            <span className="h-px w-10 bg-brand-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-brand-ember">Commercial · Contractor Partners</span>
          </div>
          <h2 className="max-w-2xl font-display text-4xl font-extrabold leading-[0.98] tracking-tight md:text-5xl">
            Dependable installation and service support for HVAC projects.
          </h2>
          <p className="mt-6 max-w-xl font-body text-base leading-relaxed text-slatex-300">
            Genuine Forge partners with GCs, HVAC companies, property managers, and building owners — with clear scope, clean handoffs, and jobsite professionalism.
          </p>
          <div className="mt-8 flex flex-wrap gap-2">
            {AUDIENCE.map((a) => (
              <span key={a} className="border border-white/15 px-4 py-2 font-mono text-[11px] uppercase tracking-widest text-slatex-300">{a}</span>
            ))}
          </div>
          <Link to="/contractor-partners" data-testid="discuss-project" className="group mt-10 inline-flex items-center gap-2 border border-white bg-white px-7 py-4 font-mono text-xs uppercase tracking-widest text-ink transition-colors hover:bg-transparent hover:text-white">
            Discuss a Project <ArrowRight size={15} weight="bold" className="transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
        <div className="grid gap-px border border-white/10 bg-white/10">
          {HIGHLIGHTS.map((h, i) => (
            <motion.div key={h} initial={{ opacity: 0, x: 20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.05 }}
              className="flex items-center gap-3 bg-ink px-6 py-4">
              <span className="font-mono text-xs text-brand-ember">{String(i + 1).padStart(2, "0")}</span>
              <span className="font-body text-sm text-white">{h}</span>
            </motion.div>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
);

export default CommercialPartner;
